import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "aip_admin_token";

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers = { ...cfg.headers, "X-Admin-Token": t };
  return cfg;
});

export const api = {
  listHotels: (params = {}) => client.get("/hotels", { params }).then((r) => r.data),
  getHotel: (id) => client.get(`/hotels/${id}`).then((r) => r.data),
  createHotel: (payload) => client.post("/hotels", payload).then((r) => r.data),
  updateHotel: (id, payload) => client.patch(`/hotels/${id}`, payload).then((r) => r.data),
  deleteHotel: (id) => client.delete(`/hotels/${id}`).then((r) => r.data),
  listRoomTypes: () => client.get("/room-types").then((r) => r.data),
  adminLogin: (password) => client.post("/admin/login", { password }).then((r) => r.data),
  adminVerify: (token) => client.get("/admin/verify", { params: { token } }).then((r) => r.data),
  adminLogout: (token) => client.post("/admin/logout", null, { params: { token } }).then((r) => r.data),
  createBooking: (payload) => client.post("/bookings", payload).then((r) => r.data),
  listBookings: (params = {}) => client.get("/bookings", { params }).then((r) => r.data),
  getBooking: (bookingId) => client.get(`/bookings/${bookingId}`).then((r) => r.data),
  lookupBooking: (params) => client.get("/bookings/lookup", { params }).then((r) => r.data),
  updateExtras: (bookingId, extras) => client.put(`/bookings/${bookingId}/extras`, { extras }).then((r) => r.data),
  updateStatus: (bookingId, status) =>
    client.patch(`/bookings/${bookingId}/status`, { booking_status: status }).then((r) => r.data),
  updatePayment: (bookingId, payment_status, payment_method) =>
    client.patch(`/bookings/${bookingId}/payment`, { payment_status, payment_method }).then((r) => r.data),
  deleteBooking: (bookingId) => client.delete(`/bookings/${bookingId}`).then((r) => r.data),
  cashReport: (params = {}) => client.get("/reports/cash-collection", { params }).then((r) => r.data),
};
